import { render, staticRenderFns } from "./CharSheet.vue?vue&type=template&id=3615c2ec&scoped=true"
import script from "./CharSheet.vue?vue&type=script&lang=ts"
export * from "./CharSheet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615c2ec",
  null
  
)

export default component.exports